<template>

  <v-main>

    <v-container
        id="dashboard-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-account-details-outline"
          class="px-5 py-3"
      >


        <v-row no-gutters>
          <v-col class="pt-5">
            <p>Welcome<span v-if="user.firstName"> {{ user.firstName }}</span>, </p>
          </v-col>
        </v-row>

        <div data-cy="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>


        <v-container
          class="d-flex flex-column align-center"
        >

          <v-row justify="space-around">
            <v-col cols="12" lg="6" class="text-center">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'stripe_payment' }"
              >
                <v-icon left>
                  mdi-cash-100
                </v-icon>
                Make Payment
              </v-btn>

            </v-col>


            <v-col cols="12" lg="6" class="text-center">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'add_claim' }"
              >
                <v-icon left>
                  mdi-lifebuoy
                </v-icon>
                Submit Claim
              </v-btn>

            </v-col>

            <v-col cols="12" lg="6" class="text-center">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'add_dependent' }"
              >
                <v-icon left>
                  mdi-account-child-outline
                </v-icon>
                Add Dependent
              </v-btn>

            </v-col>

            <v-col cols="12" lg="6" class="text-center">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'account' }"
              >
                <v-icon left>
                  mdi-account-details-outline
                </v-icon>
                Account Details
              </v-btn>

            </v-col>

            <v-col cols="12" lg="6" class="text-center">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'update_password' }"
              >
                <v-icon left>
                  mdi-lock-reset
                </v-icon>
                Change Password
              </v-btn>

            </v-col>


            <v-col cols="12" lg="6" class="text-center pb-10">

              <v-btn
                  tile
                  color="success"
                  width="80%"
                  :to="{ name: 'logout' }"
              >
                <v-icon left>
                  mdi-logout
                </v-icon>
                Log Out
              </v-btn>

            </v-col>

          </v-row>

        </v-container>
      </base-material-card>

    </v-container>
  </v-main>

</template>

<script>


import {mapGetters} from 'vuex'
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'
import api from '@/services/api'

export default {
  name: "CoreDashboardView",
  async created() {
    this.userId = this.getUserId

    if (this.userId !== null) {
      await this.fetchUser()
    }
  },
  components: {
    SharedPageMessages
  },
  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      getName: 'getName'
    }),
  },
  watch: {
    user() {
      if (this.user.isSuspended) {
        this.warningMessages.push("Your account is currently suspended. Please visit \"View Suspensions\" page for more details")
      }
    }
  },

  methods: {
    async fetchUser() {
      return api
          .fetchUser(this.userId)
          .then(response => {
            this.user = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      user: {},
      baseUrl: process.env.BASE_URL,
    }
  }
};

</script>

<style lang="scss">

th.resource-link {
  width: 10%;
}

</style>
